import { ChangeOpacityComponents, ChangeOpacityMessage, ChangeOpacityMessagePrefix } from 'game-ui-types'

const lastPayloadByComponent = new Map<string, ChangeOpacityMessage['payload']>()

window.addEventListener('message', (event: MessageEvent<ChangeOpacityMessage>) => {
    const type = event.data?.type

    if (typeof type !== 'string' || !type.startsWith(ChangeOpacityMessagePrefix)) return

    lastPayloadByComponent.set(type.slice(ChangeOpacityMessagePrefix.length), event.data.payload)
})

export const getLastOpacityPayload = (componentKey: ChangeOpacityComponents) =>
    lastPayloadByComponent.get(componentKey) ?? null
